// F-15 (QF15-2): tombstones for notes deleted on THIS device. A note the user deleted must never come back — not from
// a first save whose response was lost (it may still land later), not from the device-copy recovery sweep, not from a
// refresh or a live update. Each deleted id is kept here for 24 h (ids + times only, no note content); while a
// tombstoned id is seen again, it is hidden and deleted again on the server.
//   • `done` = the server is known not to have the row (a confirmed delete, or "never created"); `done:false` = a delete
//     is still owed (offline, or the id came back) → flushed when online, at app start and on every `online`.
//   • localStorage key hud_note_tomb (per user inside), KEPT across sign-out (QF15-4 = B, Eytan): an owed delete is sent
//     only when the SAME user is signed in (tombFlush acts on that user's entries only; another user's are never touched).
const KEY = 'hud_note_tomb';
const TTL = 24 * 3600 * 1000;
function _load() { try { const o = JSON.parse(localStorage.getItem(KEY) || '{}'); return (o && typeof o === 'object') ? o : {}; } catch (_) { return {}; } }
function _save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) { console.error('❌ note tombstones:', e); } }
function _live(o, now) { for (const [k, v] of Object.entries(o)) if (!v || !(now - v.at <= TTL)) delete o[k]; return o; }
const _k = (uid, id) => String(uid) + ':' + String(id);

// Record a delete on this device. done=true when the server is known not to have the row.
export function tombAdd(uid, id, done) { if (!uid || !id) return; const o = _live(_load(), Date.now()); o[_k(uid, id)] = { at: Date.now(), done: !!done }; _save(o); }
export function tombDone(uid, id) { const o = _load(), v = o[_k(uid, id)]; if (v) { v.done = true; _save(o); } }
export function tombRemove(uid, id) { const o = _load(); if (o[_k(uid, id)]) { delete o[_k(uid, id)]; _save(o); } }
export function tombHas(uid, id) { if (!uid || !id) return false; const v = _load()[_k(uid, id)]; return !!(v && Date.now() - v.at <= TTL); }
// The id came back (refresh / live update / a late first save): a delete is owed again.
export function tombReopen(uid, id) { const o = _load(), v = o[_k(uid, id)]; if (v && v.done) { v.done = false; _save(o); } }

let _flushing = null;
// Send every owed delete (online only). 0 rows = the row isn't there = done. → number confirmed.
export function tombFlush(uid, supa) {
  if (!uid || !supa || navigator.onLine === false) return Promise.resolve(0);
  if (_flushing) return _flushing;
  _flushing = (async () => {
    let n = 0;
    const o = _live(_load(), Date.now()); _save(o);
    const owed = Object.entries(o).filter(([k, v]) => k.startsWith(String(uid) + ':') && !v.done).map(([k]) => k.slice(String(uid).length + 1));
    for (const id of owed) {
      try {
        const { error } = await supa.from('vault_notes').delete().eq('id', id).eq('specialist_id', uid).select('id');
        if (error) { console.error('❌ note tombstone delete:', error); continue; }
        tombDone(uid, id); n++;
      } catch (e) { console.error('❌ note tombstone delete:', e); }
    }
    return n;
  })().finally(() => { _flushing = null; });
  return _flushing;
}
